<template>
  <div v-if="isShow">
    <van-popup class="xes-checkLogin" v-model="isExist" :close-on-click-overlay="false">
      <div class="xes-checkLogin-con">
        <p class="xes-checkLogin-title">{{ title }}</p>
        <p class="xes-checkLogin-phone">{{ userInfo.phone || userInfo.name }}</p>
        <div class="xes-checkLogin-btn">
          <div class="xes-checkLogin-btn-left" @click="cancel">{{ leftBtnText }}</div>
          <div class="xes-checkLogin-btn-right" @click="confirm">{{ rightBtnText }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import axios from '../utils/axios'
import { Popup } from 'vant'

export default {
  name: 'xes-checkLogin',
  components: {
    'van-popup': Popup
  },
  props: {
    title: {
      type: String,
      default: '检测到您已有网校账号为'
    },
    leftBtnText: {
      type: String,
      default: '切换账号'
    },
    rightBtnText: {
      type: String,
      default: '快捷登录'
    },
    isOnce: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      userInfo: {}, // 用户账号信息
      isShow: true, // 显示组件
      isExist: false, // 是否显示弹框
      localName: '' // 项目标识
    }
  },
  created() {
    if(this.isOnce) {
      this.localName = location.hostname.split('.')[0] + location.pathname.replace(/\//ig, '-') + 'check'
      let _isCheck = localStorage.getItem(this.localName)
      if(_isCheck) {
        this.isShow = false
      }
    }

    axios
      .post('https://login.xueersi.com/LoginV1/checkLogin', {
        user_info: 1
      })
      .then(res => {
        if (res.stat == 1) {
          this.userInfo = res.data.user_info
          this.isExist = true
          if(this.isOnce) {
            localStorage.setItem(this.localName, true)
          }
          this.$emit('hasLogin', res.data)
        } else {
          this.$emit('noLogin')
        }
      })
  },
  methods: {
    cancel() {
      this.isExist = false
      this.$emit('leftBtn', this.userInfo)
    },
    confirm() {
      this.isExist = false
      this.$emit('rightBtn', this.userInfo)
    }
  }
}
</script>
<style lang="less" scoped>
.xes-checkLogin {
  background-color: #fff;
  border-radius: 10px;

  &-con {
    width: 283px;
    padding-top: 28px;
    font-size: 15px;
    text-align: center;
    color: #333;
  }

  &-phone {
    padding: 30px 0 20px;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 2px;
  }

  &-btn {
    display: flex;
    height: 46px;
    line-height: 46px;
    border-top: 1px solid #f1f1f1;

    &-left {
      width: 50%;
      color: #666;
    }

    &-right {
      width: 50%;
      color: #f13232;
      border-left: 1px solid #f1f1f1;
    }
  }
}
</style>
